import { Checkbox, FormControlLabel } from "@mui/material";
import { getLocalStorageMenuItem, SARIconThemeColor, setMobileButttonBackColor, setMobileTextColor } from "../../../utility";

const CheckModifiers = (props) => {
  const handleChange = (event) => {
    const values = { ...props.values };
    if (event.checked) {
      const array = [...values.modifiers];
      const index = array.findIndex(
        (element) => element.id === props.modifier.group.id
      );
      if (index === -1) {
        const modifier = {
          id: props.modifier.group.id,
          min: props.modifier.min,
          max: props.modifier.max,
          order_options: [props.order.id],
        };
        array.push(modifier);
        props.setFieldValue("modifiers", array);
        props.setFieldValue("price", values.price + props.order.price);
      } else {
        const modifier = { ...array[index] };
        const orderOptions = [...modifier.order_options];
        orderOptions.push(props.order.id);
        modifier.order_options = [...orderOptions];
        array[index] = modifier;
        props.setFieldValue("modifiers", array);
        props.setFieldValue("price", values.price + props.order.price);
      }
    } else {
      const array = [...values.modifiers];
      const index = array.findIndex(
        (element) => element.id === props.modifier.group.id
      );
      const modifier = { ...array[index] };
      const orderOptions = [...modifier.order_options];
      const filterdOrders = orderOptions.filter(
        (element) => element !== props.order.id
      );
      modifier.order_options = filterdOrders;
      array[index] = modifier;
      props.setFieldValue("modifiers", array);
      props.setFieldValue("price", values.price - props.order.price);
    }
  };

  const index = props?.values?.modifiers?.findIndex(
    (element) => element.id === props.modifier.group.id
  );

  const customCheckStyles = {
    color:
      getLocalStorageMenuItem("theme") === "dark" ||
      getLocalStorageMenuItem("theme") === "white"
        ? "#6BA5F2"
        : setMobileButttonBackColor(), // Color when not selected
  };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <FormControlLabel
        control={<Checkbox style={customCheckStyles}/>}
        value={JSON.stringify(props.order)}
        checked={props?.values?.modifiers[index]?.order_options?.includes(
          props.order.id
        )}
        label={
          <span className="sub-font" style={{ color: setMobileTextColor() }}>
            {props?.order.name}
          </span>
        }
        onChange={(e) => handleChange(e.target)}
      />

      <span
        className="head-font mx-2 font-size-16"
        style={{ color: setMobileTextColor() }}
      >
        {props?.order?.price} {props?.currency ? props?.currency === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()}  className="mr-1" /> : props?.currency : ""}
      </span>
    </div>
  );
};

export default CheckModifiers;
